import { render } from "./ReceiverView.vue?vue&type=template&id=38096417&lang=html"
import script from "./ReceiverView.vue?vue&type=script&lang=js"
export * from "./ReceiverView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__